import React, { useState } from "react";

const words = [
    { word: "JAVASCRIPT", hint: "Linguaggio di programmazione web" },
    { word: "ALGORITMO", hint: "Sequenza di istruzioni" },
    { word: "DATABASE", hint: "Archivio di dati strutturati" },
    { word: "FRAMEWORK", hint: "Struttura per sviluppare app" },
    { word: "DEBUGGING", hint: "Processo di correzione errori" },
    { word: "FRONTEND", hint: "Parte visibile di un'app" },
    { word: "BACKEND", hint: "Lato server dell'app" },
    { word: "VARIABLE", hint: "Contenitore di dati" }
];

export default function HangmanGame() {
    const [gameData, setGameData] = useState(() => words[Math.floor(Math.random() * words.length)]);
    const [guessedLetters, setGuessedLetters] = useState([]);
    const [wrongGuesses, setWrongGuesses] = useState(0);
    const [gameStatus, setGameStatus] = useState("playing"); // playing, won, lost
    const [started, setStarted] = useState(false);

    const maxWrongGuesses = 6;

    const handleLetterClick = (letter) => {
        if (guessedLetters.includes(letter) || gameStatus !== "playing") return;

        const newGuessed = [...guessedLetters, letter];
        setGuessedLetters(newGuessed);

        if (!gameData.word.includes(letter)) {
            const newWrong = wrongGuesses + 1;
            setWrongGuesses(newWrong);
            if (newWrong >= maxWrongGuesses) {
                setGameStatus("lost");
            }
        } else {
            // Check if won
            const allLettersGuessed = gameData.word.split("").every(l => newGuessed.includes(l));
            if (allLettersGuessed) {
                setGameStatus("won");
            }
        }
    };

    const resetGame = () => {
        setGameData(words[Math.floor(Math.random() * words.length)]);
        setGuessedLetters([]);
        setWrongGuesses(0);
        setGameStatus("playing");
        setStarted(true);
    };

    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

    if (!started) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-font" style={{marginRight:"6px"}}></i> Hangman Tech
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>Indovina la parola tech lettera per lettera!</p>
                <button
                    onClick={() => { setStarted(true); resetGame(); }}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                <i className="fas fa-font" style={{marginRight:"6px"}}></i> Hangman Tech
            </h4>

            {/* Stato vite */}
            <div style={{marginBottom:"1rem", fontSize:"0.85rem"}}>
                <span style={{color:"#ef4444"}}>❤️ Vite: {maxWrongGuesses - wrongGuesses}</span>
            </div>

            {/* Hint */}
            <div style={{
                padding:"0.6rem",
                background:"rgba(59,130,246,0.1)",
                borderRadius:"0.5rem",
                marginBottom:"1rem",
                fontSize:"0.8rem",
                color:"#94a3b8"
            }}>
                <i className="fas fa-lightbulb" style={{marginRight:"6px", color:"#facc15"}}></i>
                {gameData.hint}
            </div>

            {/* Parola da indovinare */}
            <div style={{
                fontSize:"1.5rem",
                fontWeight:"700",
                letterSpacing:"0.3rem",
                marginBottom:"1.5rem",
                fontFamily:"monospace",
                color:"#00ffa3"
            }}>
                {gameData.word.split("").map((letter, i) => (
                    <span key={i} style={{margin:"0 2px"}}>
                        {guessedLetters.includes(letter) ? letter : "_"}
                    </span>
                ))}
            </div>

            {/* Tastiera */}
            {gameStatus === "playing" && (
                <div style={{
                    display:"grid",
                    gridTemplateColumns:"repeat(7, 1fr)",
                    gap:"0.3rem",
                    marginBottom:"1rem"
                }}>
                    {alphabet.map(letter => (
                        <button
                            key={letter}
                            onClick={() => handleLetterClick(letter)}
                            disabled={guessedLetters.includes(letter)}
                            style={{
                                padding:"0.4rem",
                                borderRadius:"0.3rem",
                                border:"1px solid rgba(255,255,255,0.1)",
                                background: guessedLetters.includes(letter)
                                    ? gameData.word.includes(letter)
                                        ? "rgba(34,197,94,0.2)"
                                        : "rgba(239,68,68,0.2)"
                                    : "rgba(255,255,255,0.05)",
                                color: guessedLetters.includes(letter) ? "#64748b" : "#fff",
                                cursor: guessedLetters.includes(letter) ? "not-allowed" : "pointer",
                                fontSize:"0.7rem",
                                fontWeight:"600",
                                opacity: guessedLetters.includes(letter) ? 0.5 : 1
                            }}
                        >
                            {letter}
                        </button>
                    ))}
                </div>
            )}

            {/* Risultato */}
            {gameStatus === "won" && (
                <div style={{
                    padding:"1rem",
                    background:"rgba(34,197,94,0.2)",
                    borderRadius:"0.5rem",
                    marginBottom:"1rem",
                    border:"1px solid rgba(34,197,94,0.3)"
                }}>
                    <p style={{fontSize:"1.2rem", color:"#22c55e", fontWeight:"700", marginBottom:"0.5rem"}}>
                        🎉 Hai vinto!
                    </p>
                    <p style={{fontSize:"0.85rem", color:"#94a3b8"}}>
                        La parola era: <strong style={{color:"#00ffa3"}}>{gameData.word}</strong>
                    </p>
                </div>
            )}

            {gameStatus === "lost" && (
                <div style={{
                    padding:"1rem",
                    background:"rgba(239,68,68,0.2)",
                    borderRadius:"0.5rem",
                    marginBottom:"1rem",
                    border:"1px solid rgba(239,68,68,0.3)"
                }}>
                    <p style={{fontSize:"1.2rem", color:"#ef4444", fontWeight:"700", marginBottom:"0.5rem"}}>
                        💀 Game Over!
                    </p>
                    <p style={{fontSize:"0.85rem", color:"#94a3b8"}}>
                        La parola era: <strong style={{color:"#00ffa3"}}>{gameData.word}</strong>
                    </p>
                </div>
            )}

            {gameStatus !== "playing" && (
                <button
                    onClick={resetGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer",
                        width:"100%"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Nuova Parola
                </button>
            )}
        </div>
    );
}